/**
 * API Configuration
 * Central configuration for all API endpoints
 * @deprecated Use httpClient from lib/httpClient.ts and API_CONFIG from api-config.ts instead
 *
 * SECURITY: All API calls MUST go through the gateway for:
 * - JWT authentication
 * - Account isolation (X-Account-ID headers)
 * - Row-Level Security enforcement
 * - Rate limiting and audit logging
 */

import { API_CONFIG } from './api-config';

// ✅ Determine API base URL - MUST use gateway
/**
 * @deprecated Use httpClient which automatically uses GATEWAY_URL
 * Using direct service URLs bypasses authentication and account isolation
 */
export const API_BASE_URL = API_CONFIG.GATEWAY_URL; // ✅ Changed from ORCHESTRATOR_URL

// ✅ Agent service URLs - all through gateway
export const AGENT_URLS = {
  NOTE_AGENT: `${API_CONFIG.GATEWAY_URL}/agents/note`,
  EMAIL_AGENT: `${API_CONFIG.GATEWAY_URL}/agents/email`,
  DOCUMENT_AGENT: `${API_CONFIG.GATEWAY_URL}/agents/document`,
}

// WebSocket configuration
/**
 * @deprecated Use API_CONFIG.WS_GATEWAY_URL directly
 * ✅ TASK-083: WebSocket now uses gateway for account isolation and JWT authentication
 */
export const WS_BASE_URL = API_CONFIG.WS_GATEWAY_URL;

// API timeout settings
export const API_TIMEOUTS = {
  DEFAULT: 30000, // 30 seconds
  LONG_RUNNING: 120000, // 2 minutes for operations like document processing
  AGENT_CALL: 60000, // 1 minute for agent calls
}

// Feature flags
export const FEATURES = {
  USE_MOCK_API: import.meta.env.VITE_USE_MOCK_API === 'true',
  ENABLE_FINSA_COMPLIANCE: true,
  ENABLE_VOICE_COMMANDS: false,
}